import { useSearchParams, useLocation, Link } from 'react-router-dom';
import { CheckCircle, XCircle, Package, Home, Building2, Truck, Copy, Check } from 'lucide-react';
import { useState } from 'react';

export default function PaymentResult() {
    const [params] = useSearchParams();
    const location = useLocation();
    const [copiedIban, setCopiedIban] = useState(false);

    // From URL params (iyzico callback)
    const status = params.get('status');
    const orderNumber = params.get('order');
    const error = params.get('error');

    // From navigate state (alternative payments)
    const stateOrder = location.state?.order;
    const statePaymentMethod = location.state?.paymentMethod;

    const isSuccess = status === 'success' || !!stateOrder;
    const displayOrderNumber = orderNumber || stateOrder?.orderNumber;

    const copyIban = (iban) => {
        navigator.clipboard.writeText(iban.replace(/\s/g, ''));
        setCopiedIban(true);
        setTimeout(() => setCopiedIban(false), 2000);
    };

    return (
        <div className="payment-result-page">
            <div className="payment-result-card">
                {isSuccess ? (
                    <>
                        <CheckCircle size={64} color="var(--success)" strokeWidth={1.5} />
                        <h1>Siparişiniz Alındı!</h1>
                        <p>Sipariş numaranız: <strong>#{displayOrderNumber}</strong></p>

                        {statePaymentMethod === 'cash_on_delivery' && (
                            <div className="payment-result-info">
                                <Truck size={24} />
                                <p>Kapıda ödeme seçeneğini tercih ettiniz. Siparişiniz hazırlanarak kargoya verilecektir. Ödemeyi teslimat sırasında nakit veya kart ile yapabilirsiniz.</p>
                            </div>
                        )}

                        {statePaymentMethod === 'bank_transfer' && (
                            <div className="payment-result-info">
                                <Building2 size={24} />
                                <p>Havale/EFT ile ödeme seçeneğini tercih ettiniz. Aşağıdaki hesaba ödemenizi yaptıktan sonra siparişiniz onaylanacaktır.</p>
                                <div className="payment-result-bank">
                                    <div className="checkout-bank-row"><span>Banka:</span><strong>Ziraat Bankası</strong></div>
                                    <div className="checkout-bank-row"><span>Hesap Sahibi:</span><strong>Atölye Kirpi</strong></div>
                                    <div className="checkout-bank-row">
                                        <span>IBAN:</span>
                                        <strong>TR00 0000 0000 0000 0000 0000 00</strong>
                                        <button type="button" className="checkout-copy-btn" onClick={() => copyIban('TR00 0000 0000 0000 0000 0000 00')}>
                                            {copiedIban ? <Check size={14} /> : <Copy size={14} />}
                                        </button>
                                    </div>
                                    <p className="payment-result-bank-note">Açıklama kısmına sipariş numaranızı (<strong>#{displayOrderNumber}</strong>) yazmayı unutmayın.</p>
                                </div>
                            </div>
                        )}

                        {!statePaymentMethod && (
                            <p>Siparişiniz en kısa sürede hazırlanacaktır. Sipariş durumunuzu hesabınızdan takip edebilirsiniz.</p>
                        )}

                        <div className="payment-result-actions">
                            <Link to="/hesabim" className="btn btn-primary"><Package size={18} /> Siparişlerim</Link>
                            <Link to="/" className="btn btn-secondary"><Home size={18} /> Ana Sayfa</Link>
                        </div>
                    </>
                ) : (
                    <>
                        <XCircle size={64} color="var(--danger)" strokeWidth={1.5} />
                        <h1>Ödeme Başarısız</h1>
                        <p>{error || 'Ödeme işlemi sırasında bir hata oluştu.'}</p>
                        <p>Lütfen tekrar deneyin veya farklı bir ödeme yöntemi kullanın.</p>
                        <div className="payment-result-actions">
                            <Link to="/checkout" className="btn btn-primary">Tekrar Dene</Link>
                            <Link to="/" className="btn btn-secondary"><Home size={18} /> Ana Sayfa</Link>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
